import type { PocInputValidity } from 'commons/types';
import { ExtendedValidationMessages, Select, SelectOption, SelectPropsValue } from 'commons/components';

type SelectDataPointType = {
    inputName: string;
    inputValue?: string;
    showTooltip: boolean;
    inputPlaceholder?: string;
    internalInputOptions: SelectOption[];
    inputOptions: SelectOption[];
    disableMapping: boolean;
    mappingError: PocInputValidity;
    validationMessages: ExtendedValidationMessages;
    onChange: (field: string, value: SelectPropsValue) => void;
};

export const SelectDataPoint: React.FC<SelectDataPointType> = (props) => {
    const {
        inputName,
        inputValue,
        showTooltip,
        inputPlaceholder,
        internalInputOptions,
        disableMapping,
        inputOptions,
        mappingError,
        validationMessages,
        onChange,
    } = props;

    return (
        <Select
            className="without-label"
            id={`${inputName}-${showTooltip ? 'showTooltip' : ''}`}
            name={inputName}
            value={inputValue}
            placeholder={
                inputPlaceholder ?? 'settings.integrations.active-directory.data-points.mapping.poc.placeholder'
            }
            options={internalInputOptions}
            onChange={(field, value) => onChange(field, (value as string[])[0])}
            disabled={disableMapping}
            validationMessages={validationMessages}
            validity={
                !inputValue || inputOptions.map((ip) => ip.value).includes(inputValue ?? '')
                    ? { state: 'valid' }
                    : mappingError
            }
            clearButton
        />
    );
};
